import { Controller } from "@hotwired/stimulus"
import { showToast } from "../lib/toast"
import { confirmAction } from "../lib/confirm"

// The Studio changes tab on the Feedback Loop page (Phelipe 2026-10-16):
// reviewers Approve or decline what's pending, anyone allowed puts a change
// back (Undo) or switches a list item Studio added Off / On. Every action
// swaps the row the server sends back — no reloads.
export default class extends Controller {
  static targets = ["pendingBox", "pendingRows", "pendingCount", "pendingEmpty", "rows", "empty", "row"]
  static values = { url: String, i18n: Object }

  get t() { return this.i18nValue || {} }

  approve(e) { this._act(e, "approve") }
  reject(e) { this._act(e, "reject", { title: this.t.confirm_reject_title, message: this.t.confirm_reject_body, confirmLabel: this.t.actions?.reject, danger: true }) }
  undo(e) { this._act(e, "undo", { title: this.t.confirm_undo_title, message: this.t.confirm_undo_body, confirmLabel: this.t.actions?.undo, danger: true }) }
  turnOff(e) { this._act(e, "toggle", null, { enabled: false }) }
  turnOn(e) { this._act(e, "toggle", null, { enabled: true }) }

  async _act(e, action, confirm = null, body = {}) {
    const btn = e.currentTarget
    const id = btn.dataset.id
    if (confirm) {
      const ok = await confirmAction({ ...confirm, cancelLabel: this.t.cancel || "Cancel" })
      if (!ok) return
    }
    btn.disabled = true
    const data = await this._post(`${this.urlValue}/${id}/${action}`, body)
    if (!data || data.ok === false) {
      btn.disabled = false
      showToast((data && data.error) || this.t.toasts?.failed || "That didn't work", "error")
      return
    }
    this._swap(id, data.row_html, data.status)
    this._paintCounts(data.pending_count)
    showToast(data.toast || "")
  }

  // A fresh row from the server replaces the old one; a change that just left
  // Pending review moves down into the full list.
  _swap(id, html, status) {
    const old = this.element.querySelector(`[data-studio-changes-target="row"][data-id="${id}"]`)
    if (!html) { old?.remove(); return }
    const tpl = document.createElement("template")
    tpl.innerHTML = html.trim()
    const fresh = tpl.content.firstElementChild
    if (!fresh || !old) return
    const wasPending = this.hasPendingRowsTarget && this.pendingRowsTarget.contains(old)
    if (wasPending && status !== "pending") {
      old.remove()
      this.rowsTarget.prepend(fresh)
      if (this.hasEmptyTarget) this.emptyTarget.hidden = true
    } else {
      old.replaceWith(fresh)
    }
    fresh.classList.add("bg-yellow-50")
    setTimeout(() => fresh.classList.remove("bg-yellow-50"), 3000)
  }

  _paintCounts(pending) {
    const n = Number.isFinite(pending) ? pending : this.pendingRowsTarget?.querySelectorAll('[data-studio-changes-target="row"]').length || 0
    if (this.hasPendingCountTarget) this.pendingCountTarget.textContent = n
    if (this.hasPendingEmptyTarget) this.pendingEmptyTarget.hidden = n > 0
    document.querySelectorAll("[data-studio-pending-count]").forEach((el) => {
      el.textContent = n
      el.hidden = n === 0
    })
  }

  async _post(url, body = {}) {
    const res = await fetch(url, {
      method: "POST", credentials: "same-origin", body: JSON.stringify(body),
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" }
    }).catch(() => null)
    if (!res) return null
    return res.json().catch(() => null)
  }
}
